import Vue from 'vue'
import Router from 'vue-router'

import Hello from '@/components/Hello'
import Admin from '@/components/dashboard/Admin'
import dashboard from '@/components/dashboard/Page'
import Message from '@/components/message/Message'
import MessageNew from '@/components/message/new'
import Fixture from '@/components/stats/fixture'
import User from '@/components/user/list'
import UserProfile from '@/components/user/profile/index'
import Bets from '@/components/user/bets/list'
import Transactions from '@/components/accounting/transactions'
import Orders from '@/components/accounting/orders'
import Credits from '@/components/accounting/credits'
import depositAccounts from '@/components/accounting/accounts'
import marketLimitations from '@/components/configuration/marketLimitations'

import Receipt from '@/components/accounting/receipt'
import ReceiptList from '@/components/accounting/receipt/list'
import ReceiptItem from '@/components/accounting/receipt/item'

import ReportsList from '@/components/reports/list'
import ReportDetail from '@/components/reports/detail'

import Promotions from '@/components/accounting/promotions/list'
import playedMarkets from '@/components/reports/playedMarkets'
import matchTrends from '@/components/reports/matchTrends'
import competitionTrends from '@/components/reports/competitionTrends'
import sportTrends from '@/components/reports/sportTrends'
import rewardTrends from '@/components/reports/rewardTrends'
import MoneyTransfer from '@/components/accounting/moneyTransfer'

import BankAccounts from '@/components/user/account/bankAccounts'
import bankAccountList from '@/components/user/account/bankAccountList'
import BankAccountForm from '@/components/user/account/form/bankAccount'

import Roles from '@/components/user/roles/roles'
import PermissionList from '@/components/user/roles/permissions'
import RoleList from '@/components/user/roles/list'

import AnalyticSession from '@/components/analytics/session'

import Payment from '@/components/payment/list'
import Configuration from '@/components/configuration/conf'
import BetSlipLimititations from '@/components/configuration/betSlipLimitation'
import SystemSettings from '@/components/configuration/systemSettings'
import CompanyInfo from '@/components/configuration/companyInfo'
import PrivacyPolicy from '@/components/configuration/privacyPolicy'
import UserAgreement from '@/components/configuration/userAgreement'
import DomainNames from '@/components/configuration/domains'
import SessionsList from '@/components/sessions/list'
import transactionsLimitations from '@/components/accounting/transactionsLimitations'
import BonusCalculator from '@/components/accounting/BonusCalculator'
import MarketLadder from '@/components/feed/settings/ladder'
import Region from '@/components/regions/list'
import CompetitionList from '@/components/competition/list'
import ClassList from '@/components/competition/classList.vue'
import Casino from '@/components/casino/casino'
import CasinoGameList from '@/components/casino/GameList'
import ProviderList from '@/components/casino/ProviderList'
import Terminal from '@/components/terminal/list'
import TerminalCreate from '@/components/terminal/create'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: dashboard
    },
    {
      path: '/message',
      name: 'Message',
      component: Message
    },
    {
        path: '/conversation/:id?',
        name: 'conversation',
        component: Message
    },
    {
      path: '/new-conversation/:uid',
      name: 'conversation_new',
      component: MessageNew
    },
    {
        path: '/u/:id',
        name: 'userprofile',
        component: UserProfile
    },
    {
      path: '/bonus-calculator',
      name: 'bonus_calculator',
      component: BonusCalculator
    },
    {
      path: '/fixture/',
      component: Fixture,
        meta: {
            breadcrumb: 'fixture'
        },
        subRoutes: {
            '/': {
                // Bar will be rendered inside Foo's <router-view>
                // when /foo/bar is matched
                component: Fixture,
                name: 'fixture',
                meta: {
                    breadcrumb: 'fixture'
                },
            },
        }
    },
    {
      path: '/user/:id?',
      component: User,
        name: 'users',
        meta: {
            breadcrumb: 'users'
        },
      subRoutes: {
          '/': {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: User,
              meta: {
                  breadcrumb: 'users'
              },
          },
      }
    },
    {
      path: '/roles',
      component: Roles,
      name: 'roles',
      meta: {
          breadcrumb: 'roles'
      },
      children: [
            {
                path: "permissions",
                name: "permission_list",
                component: PermissionList,
                meta: {
                    breadcrumb: 'permission_list'
                },
            },
            {
              path: "roles/:id?",
              name: "roles_list",
              component: RoleList,
              meta: {
                  breadcrumb: 'roles_list'
              },
            }
        ]
    },
    {
      path: '/terminal',
      component: { template: '<router-view></router-view>' },
      name: 'terminal',
      meta: {
          breadcrumb: 'terminal'
      },
      children  : [
            {
              path: "create",
              name: "terminal_create",
              component: TerminalCreate,
              meta: {
                  breadcrumb: 'terminal_create'
              },
            },
            {
              path: "devices",
              name: "terminal_devices",
              component: Terminal,
              meta: {
                  breadcrumb: 'terminal_devices'
              },
            },
        ]
    },
    {
      path: '/configuration',
      component: Configuration,
      name: 'configuration',
      meta: {
          breadcrumb: 'configuration'
      },
      children: [
          {
              path: "bet-slip-stake-limitations",
              name: "bet_slip_limits",
              component: BetSlipLimititations,
              meta: {
                  breadcrumb: 'bet_slip_limits'
              },
          },
        {
          path: "market-limitations",
          name: "market_limitations",
          component: marketLimitations,
          meta: {
            breadcrumb: 'market_limitations'
          },
        },
        {
          path: "market-ladder",
          name: "market_ladder",
          component: MarketLadder,
          meta: {
            breadcrumb: 'market_ladder'
          },
        },
          {
              path: "system",
              name: "system_settings",
              component: SystemSettings,
              meta: {
                  breadcrumb: 'system_settings'
              },
          },
          {
              path: "company",
              name: "company_info",
              component: CompanyInfo,
              meta: {
                  breadcrumb: 'company_info'
              },
          },
          {
              path: 'privacy-policy',
              name: 'privacy_policy',
              component: PrivacyPolicy,
              meta: {
                  breadcrumb: 'privacy_policy'
              }
          },
          {
              path: 'user-agreement',
              name: 'user_agreement',
              component: UserAgreement,
              meta: {
                  breadcrumb: 'user_agreement'
              }
          },
          {
              path: 'domain-names',
              name: 'domain_names',
              component: DomainNames,
              meta: {
                  breadcrumb: 'domain_names'
              }
          },
          {
              path: 'transactions-limitations',
              name: 'transactions_limitations',
              component: transactionsLimitations,
              meta: {
                  breadcrumb: 'transactions_limitations'
              }
          },
      ]
    },
    {
      path: '/bets/:id?',
      component: Bets,
      name: 'bets',
      meta: {
          breadcrumb: 'bets'
      },
      subRoutes: {
          '/': {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: Bets,
              meta: {
                  breadcrumb: 'bets'
              },
          },
      }
    },
    {
      path: '/casino-transactions/:id?',
      component: Transactions,
      name: 'casino_transactions',
      meta: {
        breadcrumb: 'transactions'
      },
      subRoutes: {
        '/': {
          // Bar will be rendered inside Foo's <router-view>
          // when /foo/bar is matched
          component: Transactions,
          meta: {
            breadcrumb: 'transactions'
          },
        },
      }
    },
    {
      path: '/transactions/:id?',
      component: Transactions,
      name: 'transactions',
      meta: {
          breadcrumb: 'transactions'
      },
      subRoutes: {
          '/': {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: Transactions,
              meta: {
                  breadcrumb: 'transactions'
              },
          },
      }
    },
    {
      path: '/orders/:id?',
      component: Orders,
      name: 'orders',
      meta: {
          breadcrumb: 'orders'
      }
    },
    {
      path: '/payment-methods/:id?',
      component: Payment,
      name: 'payment_methods',
      meta: {
          breadcrumb: 'payment_methods'
      }
    },
    {
      path: '/credits/:id?',
      component: Credits,
      name: 'credits',
      meta: {
          breadcrumb: 'credits'
      },
      subRoutes: {
          '/': {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: Credits,
              meta: {
                  breadcrumb: 'credits'
              },
          },
      }
    },
    {
      path: '/deposit-accounts/:id?',
      component: depositAccounts,
      name: 'deposit_accounts',
      meta: {
          breadcrumb: 'deposit_accounts'
      },
      subRoutes: {
          '/': {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: depositAccounts,
              meta: {
                  breadcrumb: 'deposit_accounts'
              },
          },
      }
    },
    {
      path: '/receipts',
      component: Receipt,
        children: [
          {
              path: '',
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              component: ReceiptList,
              name: 'receipts',
              meta: {
                  breadcrumb: 'receipts'
              },
          },
          {
              // Bar will be rendered inside Foo's <router-view>
              // when /foo/bar is matched
              path: 'item/:id?',
              component: ReceiptItem,
              name: 'receipt_detail',
              meta: {
                  breadcrumb: 'receipt_detail'
              },
          },
      ]
    },
    {
      path: '/money-transfer',
      component: MoneyTransfer,
      name: 'money_transfer',
      meta: {
        breadcrumb: 'promotions'
      },
    },
    {
      path: '/promotions/:id?',
      component: Promotions,
      name: 'promotions',
      meta: {
          breadcrumb: 'promotions'
      },
    },
    {
      path: '/report/present/:id',
      component: ReportDetail,
      name: 'report_present',
      meta: {
          breadcrumb: 'report_present'
      },
    },
    {
      path: '/reports',
      component: ReportsList,
      name: 'reports',
      meta: {
          breadcrumb: 'reports'
      },
    },
    {
      path: '/report/bet-market/:market?',
      component: playedMarkets,
      name: 'bet_trends',
      meta: {
          breadcrumb: 'bet_trends'
      },
    },
    {
      path: '/report/bet-match',
      component: matchTrends,
      name: 'match_trends',
      meta: {
          breadcrumb: 'match_trends'
      },
    },
    {
      path: '/report/competition-match',
      component: competitionTrends,
      name: 'competition_trends',
      meta: {
          breadcrumb: 'competition_trends'
      },
    },
    {
      path: '/report/sport-match',
      component: sportTrends,
      name: 'sport_trends',
      meta: {
          breadcrumb: 'sport_trends'
      },
    },
    {
      path: '/report/bet-user-rewards',
      component: rewardTrends,
      name: 'bet_award_history',
      meta: {
          breadcrumb: 'bet_award_history'
      },
    },
    {
      // UserProfile will be rendered inside User's <router-view>
      path: '/bank-accounts',
      component: BankAccounts,
      children: [
          {
              path: '/',
              component: bankAccountList,
              name: 'bank_accounts',
              meta: {
                  mainMenu: 1,
                  breadcrumb: 'bank_accounts'
              },
          },
          {
              // UserProfile will be rendered inside User's <router-view>
              path: 'create',
              component: BankAccountForm,
              name: 'bank_account_create',
              meta: {
                  mainMenu: 1,
                  breadcrumb: 'bank_account_create'
              },
          },
          {
              // UserProfile will be rendered inside User's <router-view>
              path: 'edit/:id?',
              component: BankAccountForm,
              name: 'bank_account_edit',
              meta: {
                  mainMenu: 1,
                  breadcrumb: 'bank_account_edit'
              },
          },

      ]
    },
    {
      path: '/analytics/session',
      component: AnalyticSession,
      name: 'session_analytics',
      meta: {
          breadcrumb: 'session_analytics'
      },
    },
    {
      path: '/sessions/:id?',
      component: SessionsList,
      name: 'sessions',
      meta: {
          breadcrumb: 'sessions'
      },
    },
    {
      path: '/region',
      component: Region,
      name: 'regions',
      meta: {
        breadcrumb: 'regions'
      },
      children: []
    },
    {
      path: '/competition',
      component: CompetitionList,
      name: 'competition',
      meta: {
        breadcrumb: 'competition'
      },
    },
    {
      path: '/class',
      component: ClassList,
      name: 'class',
      meta: {
        breadcrumb: 'class'
      },
    },
    {
      path: '/casino',
      component: Casino,
      name: 'casino',
      meta: {
        breadcrumb: 'casino'
      },
      children: [
        {
          path: "games/:id?",
          name: "games",
          component: CasinoGameList,
          meta: {
            breadcrumb: 'games'
          },
        },
        {
          path: "providers",
          name: "providers",
          component: ProviderList,
          meta: {
            breadcrumb: 'providers'
          },
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js